import { AutogenModelEdiApiUser, AutogenRowEdiApiUser } from "./autogen/AutogenModelEdiApiUser";

export class ModelEdiApiUser extends AutogenModelEdiApiUser<RowEdiApiUser> {
	constructor() {
		super(RowEdiApiUser);
	}
}

export class RowEdiApiUser extends AutogenRowEdiApiUser {
}